import React from "react";

function ConnectCustomPost() {
  return <div>ConnectCustomPost</div>;
}

export default ConnectCustomPost;
